import { Alert, AlertTitle, styled } from '@mui/material';
import { WarningAmber as WarningAmberIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useReservationFormMachines } from '../ReservationFormMachinesContext';
import { LevelOfCareContext } from '../machines/levelOfCare.machine';
import { useFieldActorSnapshot } from '../useFieldActorSnapshot';

const StyledMessage = styled(Alert)(({ theme }) => ({
  maxWidth: 400,
  transition: 'all 0.2s ease-in-out',
}));

const CareLevelMismatchMessage = ({ index }: { index: number }) => {
  const { t } = useTranslation('common');

  const { fieldRefs } = useReservationFormMachines();
  const levelOfCareActor = fieldRefs.levelOfCare;
  const levelOfCareSnapshot = useFieldActorSnapshot(levelOfCareActor);
  const { isCareLevelMismatch } =
    levelOfCareSnapshot.context as LevelOfCareContext;

  if (!isCareLevelMismatch[index]) {
    return null;
  }

  return (
    <StyledMessage icon={<WarningAmberIcon color="error" />} severity={'error'}>
      <AlertTitle>
        <strong>{t('reservation.careLevelMismatchTitle')}</strong>
      </AlertTitle>
      {t('reservation.careLevelMismatchMessage')}
    </StyledMessage>
  );
};

export { CareLevelMismatchMessage };
